import { useRef } from 'react';
import useSWR from 'swr';
import { SERVICES } from 'app/shared/constants/apiConfig';
import { IStateRegulationModel } from '../interfaces';

export const useStateRegulationConfigurations = () => {
  const stateRegulationConfiguration = useRef<IStateRegulationModel[]>([]);
  const { data, mutate } = useSWR<IStateRegulationModel[]>(
    `/${SERVICES.CONFIGURATION}/state-regulation-configurations`,
  );

  if (data) {
    stateRegulationConfiguration.current = data;
  }

  return {
    refetchStateRegulationConfiguration: mutate,
    stateRegulationConfiguration: stateRegulationConfiguration.current?.slice()?.sort((stateDataFirst, stateDataSecond) => (stateDataFirst?.state || '').localeCompare(stateDataSecond?.state || '')),
  };
};
